import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEyeSlash16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "m12.97 14.03-11-11 1.06-1.06 1.567 1.567a2 2 0 0 1 .381-.037h6.044a2 2 0 0 1 1.579.772l2.183 2.807a1.5 1.5 0 0 1 0 1.842l-2.101 2.701 1.347 1.348zm-1.356-3.477L9.842 8.781a2 2 0 0 0-2.623-2.623L6.06 5h4.96a.5.5 0 0 1 .396.193L13.6 8z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ _jsx("path", { d: "m2.4 8 1.357-1.744-1.07-1.068-1.47 1.891a1.5 1.5 0 0 0 0 1.842L3.4 11.728a2 2 0 0 0 1.578.772H10L8.5 11H4.978a.5.5 0 0 1-.394-.193z" })]
	})
});
const ForwardRef = forwardRef(SvgIconEyeSlash16);
export default ForwardRef;
